export const setJwtToken = (headers, { getState, extra }: { getState: any; extra: { includeToken?: boolean } }) => {
    try {
        const cookie = document.cookie
        const jwtCookie = cookie
            .split('; ')
            .find(row => row.startsWith('token_jwt='))
            .split('token_jwt=')[1]
        headers.set('Authorization', `Bearer ${jwtCookie}`)
        return headers
    } catch {
        return headers
    }
}

export const setUserJwtToken = (headers, { getState, extra }: { getState: any; extra: { includeToken?: boolean } }) => {
    try {
        const token = localStorage.getItem('user')
        if (!token) {
            return headers
        }
        headers.set('Authorization', `Bearer ${token.split(`"`)[1]}`)
        return headers
    } catch {
        return headers
    }
}
